<template>
<div class="shopMobBanner">
    <div class="block">
        <el-carousel height="150px">
        <el-carousel-item v-for="(item, index) in setting.datalist" :key="index">
            <!-- <h3 class="small">{{ item }}</h3> -->
            <img v-lazy="item.banner.furl" alt="">
        </el-carousel-item>
        </el-carousel>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'shopMobBanner',
    data() {
        return {
            isVisited: false
        }
    },
    props: ['setting'],
    mounted() {
        this.item = Object.assign([], this.setting)
        // this.shopMob.forEach(obj => {
        //     if (obj.compName === 'shopMobBanner') {
        //         this.item = Object.assign([], obj)
        //     }
        // })
    },
    methods: {
        ...mapActions([
            'setShopMob'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom'
        ])
    },
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.shopMobBanner {
    .block{
        .el-carousel{
            .el-carousel__container{
                width: 15rem;
                height: 5.6rem;
                .el-carousel__item{
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .el-carousel__indicators{
                .el-carousel__indicator{
                    .el-carousel__button{
                        width: 0.32rem;
                        height: 0.32rem;
                        border-radius: 50%;
                        background: #22789B;
                    }
                }
                .is-active{
                    .el-carousel__button{
                        background: #409EFF;
                    }
                }
            }
        }
    }
}
</style>
